import { IndexHeader } from "pages/index/IndexHeader";


export class LdsRouter {
    public static createLdsRoute(router, loadBody) {
        this.registerRouter("/lds/:page/#:anchor", router, loadBody);
        this.registerRouter("/lds/:page", router, loadBody);
    }

    private static registerRouter(url, router, loadBody) {
        router.on(
            url,
            (params) => {
                let page = params.page as string;
                delete params.page;
                let path = page.replace(/\./g, "/");
                loadBody(
                    "pages/lds/" + path + ".json",
                    () => {
                        let anchor = params.anchor as string;
                        if (anchor != null) {
                            setTimeout(() => {
                                const elementToScrollTo = document.getElementById(anchor);
                                elementToScrollTo.scrollIntoView();
                                elementToScrollTo.classList.add("higlight-scrolled");
                                setTimeout(() => elementToScrollTo.classList.remove("higlight-scrolled"), 2500);
                            }, 0);
                        }
                    });
            },
            {
                before: (done, params) => {
                    done();
                    IndexHeader.instance.updateHeaderForApp("main");
                },
            });

    }
}
